import React from "react";
import _ from "lodash";

import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useKioskHorizontalStyles } from "./../../../../kioskstyles";

let env = require("./../../../../env");

// props has activeStep
export default function EnvironmentDisplay(props) {
  const theme = useTheme();
  const kioskstyles = useKioskHorizontalStyles();

  let environment = env.REACT_APP_ENV;

  if (environment == "PROD") {
    return (
      <div>
        <div
          id="EnvironmentDisplay"
          style={{ ...kioskstyles.EnvironmentDisplay, display: "none" }}
        >
          {environment}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div id="EnvironmentDisplay" style={kioskstyles.EnvironmentDisplay}>
        {environment}
      </div>
    </div>
  );
}
